import "./PublicProjectTypesAndCodeTemplate.css";

import { useNavigate } from "react-router-dom";

import { getPublicCodeDetailsRoute, getPublicProjectTypeRoute } from "../../utils/routes";
import { Column, LoadingSpinner, Row } from "../../widget";
import { usePublicProjectTypesAndCodeTemplate } from "./usePublicProjectTypesAndCodeTemplate";

export const PublicProjectTypesAndCodeTemplate = (): JSX.Element => {
  const navigate = useNavigate();
  const { isLoading, projectTypes, standards } = usePublicProjectTypesAndCodeTemplate();
  return (
    <div className="ProjectTypes">
      <Row spacingV="ml">
        <Column span={12}>
          <h1>Project types & standards</h1>
        </Column>
      </Row>
      <Row spacingV="2xl">
        <Column span={12}>
          <p className="body1">See project types and the codes & standards that certify them.</p>
        </Column>
      </Row>
      <Row spacingV="ml">
        <Column span={12}>
          <h2>Project types</h2>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <p className="body1">
            Projects restore, create or manage ecosystems and sometimes use engineered approaches to deliver climate and
            nature outcomes. Different types vary in how they reduce or remove carbon, where they’re most suitable, and
            the co-benefits they deliver for biodiversity, water and communities.
          </p>
        </Column>
      </Row>
      <Row spacingV="2xl">
        <Column span={12}>
          {isLoading ? (
            <LoadingSpinner size="medium" type="dark" />
          ) : (
            <div className="CodesTableWrapper">
              <table>
                <tbody>
                  <tr className="TableHeader">
                    <th>
                      <p className="body2">Project type</p>
                    </th>
                    <td>
                      <p className="body2">Description</p>
                    </td>
                  </tr>
                  {projectTypes.map((projectType) => (
                    <tr key={projectType.uuid}>
                      <th>
                        <button
                          className="BtnLink"
                          onClick={() => navigate(getPublicProjectTypeRoute(projectType.uuid))}
                        >
                          {projectType.displayName}
                        </button>
                      </th>
                      <td>
                        <p className="body2">{projectType.description}</p>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Column>
      </Row>

      <Row spacingV="ml">
        <Column span={12}>
          <h2>Code and Standards</h2>
        </Column>
      </Row>
      <Row spacingV="l">
        <Column span={12}>
          <p className="body1">
            Codes and standards set the rules for measuring, verifying and certifying project outcomes. Choose the
            framework that matches your project type, method and objectives, noting that some are established and others
            are emerging.
          </p>
        </Column>
      </Row>
      <Row>
        <Column span={12}>
          {isLoading ? (
            <LoadingSpinner size="medium" type="dark" />
          ) : (
            <div className="CodesTableWrapper">
              <table>
                <tbody>
                  <tr className="TableHeader">
                    <th>
                      <p className="body2">Code/Standard</p>
                    </th>
                    <td>
                      <p className="body2">Description</p>
                    </td>
                    <td>
                      <p className="body2">Supported project types</p>
                    </td>
                  </tr>
                  {standards.map((standard) => (
                    <tr key={standard.uuid}>
                      <th>
                        <button className="BtnLink" onClick={() => navigate(getPublicCodeDetailsRoute(standard.uuid))}>
                          {standard.displayName}
                        </button>
                      </th>
                      <td>
                        <p className="body2">{standard.description}</p>
                      </td>
                      <td>
                        <div className="BtnGroup">
                          {standard.projectTypes.map((projectType, index) => (
                            <button
                              className="BtnLink"
                              key={projectType.uuid}
                              onClick={() => navigate(getPublicProjectTypeRoute(projectType.uuid))}
                            >
                              {projectType.displayName + (index < standard.projectTypes.length - 1 ? ", " : "")}
                            </button>
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Column>
      </Row>
    </div>
  );
};
